export const browserNavigation = link => {
  window.location.assign(link);
};
//# sourceMappingURL=navigation.js.map